import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import * as Yup from "yup";
import {
  Row,
  Button,
  Form,
  Card,
  CardFooter,
  Col,
} from "reactstrap";
import { useQuery } from "react-query";
import { queryKeyes } from "shared/queryKeys";
import FormValuesDebug from "utils/debugTools/FormValuesDebug";
import apiGlobal, { apiMedia } from "global/api.global";
import {
  AlertColourTypeConstant,
  AlertTypeConstant,
  FileStatus,
  ReportingEvents,
  VesselTypeConstant,
} from "shared/constants";
import {
  Get,
} from "VesselMaster/vesselMaster.hooks";
import {
  DraftsDisplacementValidationMessages,
  commonValidationMessages,
} from "Components/ValidationErrorMessages";
import { queryClient } from "react-query/queryClient";
import { calculateSpeed, checkValidArray, checkValidObject, dynamicSetFieldErrors, handleServerResponse, isFormUnchanged, saveEditForm, useSafeFormikContext } from "GenericForms/Helper";
import env from "environment_system/env_system";
import AlertPopup from "Alerts/AlertPopup";
import { getAlertMessage } from "Alerts/AlertMessages";
import DraftsAndDisplacement from "./DraftsAndDisplacement";
import CargoDetails from "./CargoDetails";
import CargoTankParameter from "./CargoTankParameter";
import ReeferContainerComponent from "./ReeferContainer";
import BillOfLading from "./BillOfLading";
import BallastDetails from "./BallastDetails";
import BallastOperations from "./BallastOperations";
import { Formik } from "formik";
import { useDocumentTitle } from "Components/useDocument.hooks";
import { getLimitsAndAlertsAction, getCurrentReportAction, getCurrentReportFilesAction } from "Store/Generic/ReportingSlice";
import { useDispatch, useSelector } from "react-redux";
import ContainerDetails from "./ContainerDetails";
import { RootState } from "index";
import FormLoading from "Components/FormLoading";
import ErrorComponent from "Components/ErrorComponent";
import { useEditReport } from "VesselReportingInfo/EditCompletedReports/EditReportProvider";

const LoadingCTMSContext = createContext(null);
const DischargingCTMSContext = createContext(null);
export const UpdateLoadingCTMS = () => {
  return useContext(LoadingCTMSContext);
};

export const UpdateDischargingCTMS = () => {
  return useContext(DischargingCTMSContext);
};

interface DraftsCargoLadingType {
  toggleTab?: any;
  setErrorMessage?: any;
  ConfigurationLimits?: any;
}

const DraftsCargoLadingComponent = ({
  toggleTab,
  setErrorMessage,
}: DraftsCargoLadingType) => {
  const { previousDeckTabIndex, setPreviousDeckTabIndex, editReportBool } = useEditReport();
  /** State variables */
  useDocumentTitle("Drafts, Cargo Details Report - ecoSAIL");
  const { VesselID, ReportID, VoyageID, CurrentVessel, CurrentReport, PreviousReport, reportingLoading, ConfigurationLimits, reportingError } = useSelector((state: RootState) => state.Reporting);
  const dispatch = useDispatch();
  const [loadingPopOverBool, setLoadingPopOverBool] = useState<boolean>(false);
  const [loadingPopUpBool, setLoadingPopUpBool] = useState<boolean>(false);
  const [loadingCTMS, setLoadingCTMS] = useState<boolean>(false);
  const [cargoDetailsId, setCargoDetailsId] = useState<number>(0);
  const [initialLNGCargoId, setInitialLNGCargoId] = useState<number>(0);
  const [dischargingPopOverBool, setDischargingPopOverBool] = useState<boolean>(false);
  const [dischargingPopUpBool, setDischargingPopUpBool] = useState<boolean>(false);
  const [dischargingCTMS, setDischargingCTMS] = useState<boolean>(false);
  const [baplieFiles, setBaplieFiles] = useState<Array<any>>([{}]);
  const [logBook, setLogBook] = useState<Array<any>>([{}]);
  const [refreshKey, setRefreshKey] = useState<number>(0);
  const [alertBool, setAlertBool] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>(null);
  const [fieldLabel, setFieldLabel] = useState<string>(null);
  const [fieldValue, setFieldValue] = useState<any>(null);
  const [alertColourType, setAlertColourType] = useState<any>(null);
  const [alertType, setAlertType] = useState<string>(null);
  const [fieldId, setFieldId] = useState<string>(null);
  const [formTitle, setFormTitle] = useState<string>(null);
  const [previousCargoDetails, setPreviousCargoDetails] = useState(false);
  const [previousContainerDetailBool, setPreviousContainerDetailBool] = useState(false);
  const [prevRefreshKey, setPrevRefreshKey] = useState<number>(0);
  const [cargoChangePopupBool, setCargoChangePopupBool] = React.useState(false);
  const [containerChangePopupBool, setContainerChangePopupBool] = React.useState(false);
  const deleteBaplieFileObj: any = {
    baplie_file: null,
    baplie_file_path: null,
  }
  const deleteLogBookObj: any = {
    log_book_upload: null,
    log_book_file_path: null,
  }
  const formikContext = useSafeFormikContext<any>();
  const editValues = formikContext?.values;
  const setEditValues = formikContext?.setValues;
  const editInitialValues = formikContext?.initialValues;
  const editSubmit = formikContext?.submitForm;
  const editIsSubmitting = formikContext?.isSubmitting;
  const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
  const [cargoChangeState, setCargoChangeState] = useState(
    editReportBool ?
      editValues?.vessel_reporting_information?.is_this_cargo_loading_discharging
      : currentVesselReport?.is_this_cargo_loading_discharging);
  const [containerChangeState, setContainerChangeState] = useState(
    editReportBool ?
      editValues?.vessel_reporting_information?.change_in_containers_onboard
      : currentVesselReport?.change_in_containers_onboard);
  const draftsDisplacementCurrentReport = CurrentReport?.data?.deck_officer?.draft_and_displacement ?? null;
  const cargoDetailsCurrentReport = CurrentReport?.data?.deck_officer?.cargo_detail ?? null;
  const cargoDetailsPreviousReport = PreviousReport?.data?.deck_officer?.cargo_detail ?? null;
  const ballastDetailsCurrentReport = CurrentReport?.data?.deck_officer?.ballast_details ?? null;
  const billOfLadingCurrentReport = CurrentReport?.data?.deck_officer?.bill_of_lading ?? null;
  const lngCargoROBCurrentReport = CurrentReport?.data?.deck_officer?.lng_cargo_rob ?? null;
  const lngCargoROBPreviousReport = PreviousReport?.data?.deck_officer?.lng_cargo_rob ?? null;
  const containerDetailsCurrentReport = CurrentReport?.data?.deck_officer?.container_detail ?? null;
  const containerDetailsPreviousReport = PreviousReport?.data?.deck_officer?.container_detail ?? null;
  const reeferContainerDetailsCurrentReport = CurrentReport?.data?.deck_officer?.reefer_container_details ?? null;
  const reeferContainerDetailsPreviousReport = PreviousReport?.data?.deck_officer?.reefer_container_details ?? null;
  const vesselLNGTanksCurrentReport = CurrentReport?.data?.deck_officer?.vessel_reporting_lng_tank_detail ?? null;
  const reefer_container_available = ConfigurationLimits?.reefer_container_available ?? false;
  const is_container_available = ConfigurationLimits?.is_container_available ?? false;
  const VesselGenInfoObject = useMemo(
    () => ConfigurationLimits?.vessel_general_info ?? [],
    [ConfigurationLimits]);
  const [blFileUpload, setBLFileUpload] = useState<Array<any>>([]);
  /** State variables end */

  /** Queries */
  /** Initial LNG cargo ROB Object used for edit */
  const {
    data: InitialLNGCargoObject,
    isLoading: InitialLNGCargoObjectLoading,
  } = useQuery(
    [queryKeyes.vessel.InitialLNGCargoROBObject.key, VesselID],
    async () => {
      return await Get(queryKeyes.vessel.InitialLNGCargoROBObject.url(VesselID), VesselID);
    },
    { staleTime: Infinity }
  );
  /** Vessel's LNG tanks */
  const {
    data: VesselLNGTanks,
    isLoading: VesselLNGTanksLoading,
  } = useQuery(
    [queryKeyes.vessel.VesselLNGTanks.key, VesselID],
    async () => {
      return await Get(queryKeyes.vessel.VesselLNGTanks.url(VesselID), VesselID);
    },
    { staleTime: Infinity }
  );
  /** Queries end */

  /** Assign values to initial object of Drafts & Displacement */
  const getInitialDraftsDisplacement = () => {
    if (editInitialValues && editInitialValues?.deck_officer?.draft_and_displacement?.id > 0) {
      return editInitialValues?.deck_officer?.draft_and_displacement;
    } else if (checkValidObject(draftsDisplacementCurrentReport)) {
      return draftsDisplacementCurrentReport;
    } else {
      return {
        fwd_draft: null,
        draft_mid: null,
        draft_aft: null,
        displacement: null,
        trim: 0,
        vessel: VesselID,
        voyage_information: VoyageID,
        vessel_reporting_information: ReportID,
      };
    }
  };

  /** Assign values to initial object of Cargo Details */
  const getInitialCargoDetails = () => {
    if (CurrentVessel?.vessel_type_precedence_id !== VesselTypeConstant.CONTAINER) {
      if (editInitialValues && editInitialValues?.deck_officer?.cargo_detail?.id > 0) {
        return editInitialValues?.deck_officer?.cargo_detail;
      } else if (checkValidObject(cargoDetailsCurrentReport)) {
        return cargoDetailsCurrentReport;
      } else if (checkValidObject(cargoDetailsPreviousReport)) {
        const updatedPreviousCargoDetails = { ...cargoDetailsPreviousReport };
        delete updatedPreviousCargoDetails.id;
        delete updatedPreviousCargoDetails.created_by;
        delete updatedPreviousCargoDetails.created_on;
        delete updatedPreviousCargoDetails.modified_by;
        delete updatedPreviousCargoDetails.modified_on;
        updatedPreviousCargoDetails.amount_of_cargo_loaded = null;
        updatedPreviousCargoDetails.amount_of_cargo_discharged = null;
        updatedPreviousCargoDetails.cargo_detail = null;
        updatedPreviousCargoDetails.cargo_used = null;
        updatedPreviousCargoDetails.cargo_adjusted = null;
        updatedPreviousCargoDetails.adjustment_reason = null;
        updatedPreviousCargoDetails.voyage_information = VoyageID;
        updatedPreviousCargoDetails.vessel_reporting_information = ReportID;
        return updatedPreviousCargoDetails;
      } else {
        return {
          cargo_detail: "",
          amount_of_cargo_loaded: null as number,
          amount_of_cargo_discharged: null as number,
          total_amount_of_cargo_onboard: null as number,
          cargo_adjusted: 0,
          adjustment_reason: null,
          lng_foe_factor: null,
          loading: false,
          discharging: false,
          loading_completion: false,
          discharging_completion: false,
          is_loading_ctms: false,
          is_discharging_ctms: false,
          vessel: VesselID,
          voyage_information: VoyageID,
          vessel_reporting_information: ReportID,
        };
      }
    } else {
      return {};
    }
  }

  /** Assign values to initial object of Container Details */
  const getInitialContainerDetails = () => {
    if ((CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER || CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP) &&
      is_container_available === true) {
      if (editInitialValues && editInitialValues?.deck_officer?.container_detail?.id > 0) {
        return editInitialValues?.deck_officer?.container_detail;
      } else if (checkValidObject(containerDetailsCurrentReport)) {
        return containerDetailsCurrentReport;
      } else if (checkValidObject(containerDetailsPreviousReport)) {
        const updatedPreviousCargoDetails = { ...containerDetailsPreviousReport };
        delete updatedPreviousCargoDetails.id;
        delete updatedPreviousCargoDetails.created_by;
        delete updatedPreviousCargoDetails.created_on;
        delete updatedPreviousCargoDetails.modified_by;
        delete updatedPreviousCargoDetails.modified_on;
        updatedPreviousCargoDetails.loaded_container = null;
        updatedPreviousCargoDetails.discharged_container = null;
        updatedPreviousCargoDetails.OOG_units = null;
        updatedPreviousCargoDetails.reason_for_change = null;
        updatedPreviousCargoDetails.voyage_information = VoyageID;
        updatedPreviousCargoDetails.vessel_reporting_information = ReportID;
        return updatedPreviousCargoDetails;
      } else {
        return {
          loaded_container: null,
          discharged_container: null,
          total_onboard_container: null,
          feet_20: null,
          feet_40: null,
          OOG_units: null,
          reason_for_change: "",
          vessel: VesselID,
          voyage_information: VoyageID,
          vessel_reporting_information: ReportID,
        }
      };
    } else {
      return {};
    }
  }

  /** Assign values to initial object of Ballast Details */
  const getInitialBallastDetails = () => {
    if (editInitialValues && editInitialValues?.deck_officer?.ballast_details?.id > 0) {
      return editInitialValues?.deck_officer?.ballast_details;
    } else if (checkValidObject(ballastDetailsCurrentReport)) {
      return ballastDetailsCurrentReport;
    } else {
      return {
        permanent: null,
        addition: null,
        total: null,
        loaded: null,
        discharged: null,
        vessel: VesselID,
        voyage_information: VoyageID,
        vessel_reporting_information: ReportID,
      };
    }
  };
  /** Assign values to initial object of Bill of Lading */
  const getInitialBillOfLading = () => {
    if (editInitialValues && editInitialValues?.deck_officer?.bill_of_lading) {
      return editInitialValues?.deck_officer?.bill_of_lading;
    } else if (checkValidObject(billOfLadingCurrentReport)) {
      return billOfLadingCurrentReport;
    } else {
      return {
        is_bill_of_lading_issued_since_last_report: false,
        cargo_survey: false,
        letter_of_protest: false,
        bl_figure: 0,
        //bl_figure_attachment: null as any,
        ship_figure_of_bl_figure: 0,
        //survey_attachment: null as any,
        surveyor_figure_of_bl_figure: 0,
        //letter_of_protest_attachment: null as any,
        vessel: VesselID,
        voyage_information: VoyageID,
        vessel_reporting_information: ReportID,
      };
    }
  };

  /** Assign values to initial object of Reefer Container Details */
  const getInitialReeferContainerDetails = () => {
    if (editInitialValues && editInitialValues?.deck_officer?.reefer_container_details?.id > 0) {
      return editInitialValues?.deck_officer?.reefer_container_details;
    } else if ((CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER ||
      CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP) &&
      reefer_container_available === true) {
      if (checkValidObject(reeferContainerDetailsCurrentReport)) {
        return reeferContainerDetailsCurrentReport;
      } else if (checkValidObject(reeferContainerDetailsPreviousReport)) {
        const updatedPreviousReeferContainerDetails = { ...reeferContainerDetailsPreviousReport };
        delete updatedPreviousReeferContainerDetails.id;
        delete updatedPreviousReeferContainerDetails.created_by;
        delete updatedPreviousReeferContainerDetails.created_on;
        delete updatedPreviousReeferContainerDetails.modified_by;
        delete updatedPreviousReeferContainerDetails.modified_on;
        delete updatedPreviousReeferContainerDetails.report_date_time;
        updatedPreviousReeferContainerDetails.loaded_container = null;
        updatedPreviousReeferContainerDetails.discharged_container = null;
        updatedPreviousReeferContainerDetails.baplie_file_path = null;
        updatedPreviousReeferContainerDetails.baplie_file = null;
        updatedPreviousReeferContainerDetails.log_book_path = null;
        updatedPreviousReeferContainerDetails.log_book_upload = null;
        updatedPreviousReeferContainerDetails.log_book_status = null;
        updatedPreviousReeferContainerDetails.baplie_file_status = null;
        updatedPreviousReeferContainerDetails.reason_for_change = null;
        updatedPreviousReeferContainerDetails.voyage_information = VoyageID;
        updatedPreviousReeferContainerDetails.vessel_reporting_information = ReportID;
        return updatedPreviousReeferContainerDetails;
      } else {
        return {
          loaded_container: null as number,
          discharged_container: null as number,
          total_onboard_container: 0,
          baplie_file: "",
          log_book_upload: "",
          reason_for_change: "",
          baplie_file_status: FileStatus.NA,
          log_book_status: FileStatus.PENDING,
          vessel: VesselID,
          voyage_information: VoyageID,
          vessel_reporting_information: ReportID,
        };
      }
    } else {
      return {}
    }
  };

  /** Assign initial values to LNG cargo ROB formik object */
  const getLNGCargoROBInitialVals = () => {
    if (editInitialValues && editInitialValues?.deck_officer?.lng_cargo_rob?.id > 0) {
      return editInitialValues?.deck_officer?.lng_cargo_rob;
    } else if (CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER) {
      if (checkValidObject(lngCargoROBCurrentReport)) {
        return lngCargoROBCurrentReport;
      } else {
        return {
          cargo_consumed: 0,
          previous_lng_cargo_rob_id: null,
          cargo_rob: lngCargoROBPreviousReport?.cargo_rob ?? lngCargoROBCurrentReport?.cargo_rob ?? 0,
          cargo_loaded_cargo_detail: null,
          cargo_discharge_cargo_detail: null,
          lng_initial_cargo_rob: null,
          vessel: VesselID,
          voyage_information: VoyageID,
          vessel_reporting_information: ReportID,
        };
      }
    }
  };

  /** Assign initial values to initial LNG cargo ROB formik object */
  const getInitialLNGCargoROB = () => {
    if (CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER) {
      if (InitialLNGCargoObject && InitialLNGCargoObject.length > 0) {
        if (InitialLNGCargoObject[0]?.start_report === ReportID) {
          InitialLNGCargoObject[0].loading_completion = true;
        } else if (InitialLNGCargoObject[0]?.end_report === ReportID) {
          InitialLNGCargoObject[0].discharging_completion = true;
        } else {
          InitialLNGCargoObject[0].loading_completion = false;
          InitialLNGCargoObject[0].discharging_completion = false;
        }
        delete InitialLNGCargoObject[0].start_file_path;
        delete InitialLNGCargoObject[0].end_file_path;
        return InitialLNGCargoObject[0];
      } else {
        return ({
          loaded_cargo: 0,
          loading_ctms: false,
          status: "Ongoing",
          discharge_cargo: 0,
          discharge_ctms: false,
          start_report: null as number,
          end_report: null as number,
          vessel: VesselID,
        });
      }
    }
  };

  /** Assign initial values to vessel's LNG tanks formik object */
  const getVesselLNGTanks = () => {
    if (CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER) {
      if (editInitialValues && editInitialValues?.deck_officer?.vessel_reporting_lng_tank_detail[0]?.id > 0) {
        return editInitialValues?.deck_officer?.vessel_reporting_lng_tank_detail;
      } else if (checkValidArray(vesselLNGTanksCurrentReport)) {
        return vesselLNGTanksCurrentReport;
      } else {
        let array: any[] = [];
        VesselLNGTanks?.forEach((tank: any) => {
          array.push({
            temperature: null as number,
            pressure: null,
            tank: tank?.id,
            tank_name: tank?.name_of_tanks,
            vessel: VesselID,
            voyage_information: VoyageID,
            vessel_reporting_information: ReportID,
          });
        });
        return array;
      }
    }
  };

  /** UseEffect */
  useEffect(() => {
    DraftCargoLadingFormik.initialValues = {
      draft_and_displacement: getInitialDraftsDisplacement(),
      cargo_detail: getInitialCargoDetails(),
      container_detail: getInitialContainerDetails(),
      ballast_details: getInitialBallastDetails(),
      bill_of_lading: getInitialBillOfLading(),
      reefer_container_details: getInitialReeferContainerDetails(),
      lng_cargo_rob: getLNGCargoROBInitialVals(),
      n2_adjustment: getInitialLNGCargoROB(),
      vessel_reporting_lng_tank_detail: getVesselLNGTanks(),
    };
    setRefreshKey(refreshKey + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    CurrentReport,
    PreviousReport,
    VesselLNGTanks,
    InitialLNGCargoObject,
    editInitialValues
  ]);
  useEffect(() => {
    if ((currentVesselReport?.reporting_event !== ReportingEvents.NOON_FWE_IP && currentVesselReport?.reporting_event !== ReportingEvents.DEPARTURE_FROM_BERTH &&
      cargoChangeState === "no")) {
      setPreviousCargoDetails(true);
    } else {
      setPreviousCargoDetails(false);
    }
  }, [currentVesselReport, cargoChangeState])
  useEffect(() => {
    if ((currentVesselReport?.reporting_event !== ReportingEvents.NOON_FWE_IP && currentVesselReport?.reporting_event !== ReportingEvents.DEPARTURE_FROM_BERTH &&
      containerChangeState === "no")) {
      setPreviousContainerDetailBool(true);
    } else {
      setPreviousContainerDetailBool(false);
    }
  }, [currentVesselReport, containerChangeState])
  /** UseEffect end */
  /** Formik object for all forms */
  const DraftCargoLadingFormik = {
    initialValues: {
      draft_and_displacement: getInitialDraftsDisplacement(),
      cargo_detail: getInitialCargoDetails(),
      container_detail: getInitialContainerDetails(),
      ballast_details: getInitialBallastDetails(),
      bill_of_lading: getInitialBillOfLading(),
      reefer_container_details: getInitialReeferContainerDetails(),
      lng_cargo_rob: getLNGCargoROBInitialVals(),
      n2_adjustment: getInitialLNGCargoROB(),
      vessel_reporting_lng_tank_detail: getVesselLNGTanks(),
    },
    validationSchema: Yup.object().shape({
      draft_and_displacement: Yup.object({
        fwd_draft: Yup.string()
          .matches(
            /^\d{0,2}(?:\.\d{1,4})?$/,
            commonValidationMessages.before2after4
          )
          .required(commonValidationMessages.required),
        draft_mid: Yup.string()
          .matches(
            /^\d{0,2}(?:\.\d{1,4})?$/,
            commonValidationMessages.before2after4
          )
          .required(commonValidationMessages.required),
        draft_aft: Yup.string()
          .matches(
            /^\d{0,2}(?:\.\d{1,4})?$/,
            commonValidationMessages.before2after4
          )
          .required(commonValidationMessages.required),
        displacement: Yup.string()
          .matches(
            /^\d{0,6}(?:\.\d{1,4})?$/,
            DraftsDisplacementValidationMessages.displacement
          )
          .required(commonValidationMessages.required),
        trim: Yup.string()
          .test(
            "max_min_validation",
            "Trim must be between Min and Max values",
            function (value) {
              if (!value) return true;
              if (
                ConfigurationLimits?.max_trim_limit === null ||
                ConfigurationLimits?.max_trim_limit === undefined ||
                ConfigurationLimits?.min_trim_limit === null ||
                ConfigurationLimits?.min_trim_limit === undefined
              ) {
                return true;
              }
              const max = ConfigurationLimits.max_trim_limit;
              const min = ConfigurationLimits.min_trim_limit;
              const num = Number(value);
              if (isNaN(num)) return false;
              if (num < min || num > max) return false;
              return true;
            })
      }),
      cargo_detail: CurrentVessel?.vessel_type_precedence_id !== VesselTypeConstant.CONTAINER &&
        Yup.object({
          cargo_detail: Yup.string()
            .min(2, commonValidationMessages.min2)
            .max(50, commonValidationMessages.max50Char)
            .when("total_amount_of_cargo_onboard", (field: any, schema) => {
              return (parseFloat(field[0]) > 0 &&
                (cargoChangeState === "yes" ||
                  currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                  currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH
                ))
                ? schema.required(commonValidationMessages.required) : schema.nullable();
            }),
          amount_of_cargo_loaded: Yup.string()
            .when([], function () {
              if (cargoChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH
              ) {
                return Yup.string().matches(/^\d{0,7}(?:\.\d{1,4})?$/, commonValidationMessages.before7after4)
                  .required(commonValidationMessages.required);
              } else {
                return Yup.string().nullable();
              }
            }),
          amount_of_cargo_discharged: Yup.string()
            .when([], function () {
              if (cargoChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH
              ) {
                return Yup.string().matches(/^\d{0,7}(?:\.\d{1,4})?$/, commonValidationMessages.before7after4)
                  .required(commonValidationMessages.required);
              } else {
                return Yup.string().nullable();
              }
            }),
          total_amount_of_cargo_onboard: Yup.string()
            .when([], function () {
              if (cargoChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH
              ) {
                return Yup.string()
                  .matches(
                    /^\d{0,7}(?:\.\d{1,4})?$/,
                    commonValidationMessages.before7after4
                  )
                  .test(
                    'max-dead-weight',
                    `Value cannot be greater than ${ConfigurationLimits?.dead_weight}`,
                    function (value) {
                      if (!value || !ConfigurationLimits?.dead_weight) return true;
                      return parseFloat(value) <= ConfigurationLimits.dead_weight;
                    }
                  )
                  .required(commonValidationMessages.required);
              } else {
                return Yup.string().nullable();
              }
            }),
          cargo_adjusted: Yup.string()
            .matches(
              /^[+-]?\d{0,7}(?:\.\d{1,4})?$/,
              commonValidationMessages.before7after4
            )
            .nullable(),
          adjustment_reason: Yup.string()
            .when("cargo_adjusted", (val: any, schema) => {
              return (val && val[0] !== '0' &&
                CurrentVessel.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER &&
                cargoChangeState === 'yes')
                ? schema.required(commonValidationMessages.required)
                : schema.nullable();
            })
            .max(50, commonValidationMessages.max50Char),
        }),
      container_detail:
        ((CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER || CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP) &&
          is_container_available === true) &&
        Yup.object({
          OOG_units: Yup.string()
            .when([], function () {
              if (containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH) {
                return Yup.string().matches(/^\d{1,7}$/, commonValidationMessages.wholenumberupto7digits)
                  .required(commonValidationMessages.required);
              } else {
                return Yup.string().nullable();
              }
            }),
          reason_for_change: Yup.string()
            .min(2, commonValidationMessages.min2)
            .max(50, commonValidationMessages.max50Char)
            .when("total_onboard_container", (field: any, schema) => {
              return (parseFloat(field[0]) > 0 &&
                (containerChangeState === "yes" ||
                  currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                  currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH))
                ? schema.required(commonValidationMessages.required) : schema.nullable()
            }),
          loaded_container: Yup.string()
            .when([], function () {
              if (containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH) {
                return Yup.string().matches(/^\d{1,7}$/, commonValidationMessages.wholenumberupto7digits)
                  .required(commonValidationMessages.required);
              } else {
                return Yup.string().nullable();
              }
            }),
          discharged_container: Yup.string()
            .when([], function () {
              if (containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH) {
                return Yup.string().matches(/^\d{1,7}$/, commonValidationMessages.wholenumberupto7digits)
                  .required(commonValidationMessages.required);
              } else {
                return Yup.string().nullable();
              }
            }),
          total_onboard_container: Yup.string()
            .nullable()
            .when([], function () {
              const shouldValidate =
                containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH;
              if (!shouldValidate) return Yup.string().nullable();
              return Yup.string()
                .matches(/^\d{1,7}$/, commonValidationMessages.wholenumberupto7digits)
                .required(commonValidationMessages.required)
                .test(
                  'check-it-should-not-more-than-max-teu', 'Should not be more than max teu',
                  function (value) {
                    const maxTeu = ConfigurationLimits?.max_teu;
                    const total = parseFloat(value ?? "0");
                    return total <= maxTeu;
                  }
                );
            }),
          feet_20: Yup.string()
            .when(['loaded_container', 'discharged_container'], function () {
              if ((containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH)
              ) {
                return Yup.string().matches(/^\d{1,7}$/, commonValidationMessages.wholenumberupto7digits)
                  .required(commonValidationMessages.required);
              } else {
                return Yup.string().nullable();
              }
            }),
          feet_40: Yup.string()
            .when(['loaded_container', 'discharged_container'], function () {
              if ((containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH)
              ) {
                return Yup.string().matches(/^\d{1,7}$/, commonValidationMessages.wholenumberupto7digits)
                  .required(commonValidationMessages.required);
              } else {
                return Yup.string().nullable();
              }
            }),
        }),
      ballast_details: Yup.object({
        permanent: Yup.string()
          .matches(
            /^\d{0,7}(?:\.\d{1,4})?$/,
            commonValidationMessages.before7after4
          )
          .required(commonValidationMessages.required),
        addition: Yup.string()
          .matches(
            /^\d{0,7}(?:\.\d{1,4})?$/,
            commonValidationMessages.before7after4
          )
          .required(commonValidationMessages.required),
        total: Yup.string()
          .matches(
            /^\d{0,7}(?:\.\d{1,4})?$/,
            commonValidationMessages.before7after4
          )
          .required(commonValidationMessages.required),
        loaded: Yup.string()
          .matches(
            /^\d{0,7}(?:\.\d{1,4})?$/,
            commonValidationMessages.before7after4
          )
          .required(commonValidationMessages.required),
        discharged: Yup.string()
          .matches(
            /^\d{0,7}(?:\.\d{1,4})?$/,
            commonValidationMessages.before7after4
          )
          .required(commonValidationMessages.required),
      }),
      bill_of_lading: Yup.object({
        is_bill_of_lading_issued_since_last_report: Yup.boolean(),
        cargo_survey: Yup.boolean(),
        letter_of_protest: Yup.boolean(),
        bl_figure: Yup.string().when("is_bill_of_lading_issued_since_last_report", {
          is: true,
          then: (schema: any) => schema.matches(
            /^\d{0,7}(?:\.\d{1,4})?$/,
            commonValidationMessages.before7after4
          ).required(commonValidationMessages.required),
          otherwise: (schema: any) => schema.nullable(),
        }),
        //bl_figure_attachment: Yup.string().nullable(),
        ship_figure_of_bl_figure: Yup.string().when("is_bill_of_lading_issued_since_last_report", {
          is: true,
          then: (schema: any) => schema.matches(
            /^\d{0,7}(?:\.\d{1,4})?$/,
            commonValidationMessages.before7after4
          ).required(commonValidationMessages.required),
          otherwise: (schema: any) => schema.nullable(),
        }),
        //survey_attachment: Yup.string().nullable(),
        surveyor_figure_of_bl_figure: Yup.string()
          .when('cargo_survey', {
            is: true,
            then: (schema) => schema.matches(
              /^\d{0,7}(?:\.\d{1,4})?$/,
              commonValidationMessages.before7after4
            ).required(commonValidationMessages.required),
            otherwise: (schema) => schema.nullable()
          }),
        //letter_of_protest_attachment: Yup.string().nullable(),
      }),
      vessel_reporting_lng_tank_detail: Yup.array(
        Yup.object({
          temperature: Yup.number()
            .min(-180, commonValidationMessages.min_180)
            .max(50, commonValidationMessages.max50)
            .required(commonValidationMessages.required),
          pressure: Yup.number()
            .min(0, commonValidationMessages.min0)
            .max(250, commonValidationMessages.max250)
            .required(commonValidationMessages.required),
        })
      ),
      reefer_container_details:
        ((CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER || CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP) &&
          reefer_container_available === true) &&
        Yup.object({
          reason_for_change: Yup.string()
            .min(2, commonValidationMessages.min2)
            .max(50, commonValidationMessages.max50Char)
            .when("total_onboard_container", (field: any, schema) => {
              return (parseFloat(field[0]) > 0 &&
                (containerChangeState === "yes" ||
                  currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                  currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH))
                ? schema.required(commonValidationMessages.required) : schema.nullable();
            }),
          loaded_container: Yup.number()
            .typeError(commonValidationMessages.number)
            .integer(commonValidationMessages.integer)
            .min(0, commonValidationMessages.positive)
            .max(999999, commonValidationMessages.max6)
            .when((_value: any, schema: any) => {
              if (containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH) {
                return schema.required(commonValidationMessages.required);
              } else {
                return schema.nullable();
              }
            }),
          discharged_container: Yup.number()
            .typeError(commonValidationMessages.number)
            .integer(commonValidationMessages.integer)
            .min(0, commonValidationMessages.positive)
            .max(999999, commonValidationMessages.max6)
            .when((_value: any, schema: any) => {
              if (containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH) {
                return schema.required(commonValidationMessages.required);
              } else {
                return schema.nullable();
              }
            }),
          total_onboard_container: Yup.number()
            .integer(commonValidationMessages.integer)
            .min(0, commonValidationMessages.positive)
            .max(999999, commonValidationMessages.max6)
            .when((_value: any, schema: any) => {
              if (containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH) {
                return schema.required(commonValidationMessages.required);
              } else {
                return schema.nullable();
              }
            }),
          feet_20: Yup.string()
            .when(['loaded_container', 'discharged_container'], function () {
              if ((containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH)) {
                return Yup.string().matches(/^\d{1,7}$/, commonValidationMessages.wholenumberupto7digits)
                  .required(commonValidationMessages.required);
              } else {
                return Yup.string().nullable();
              }
            }),
          feet_40: Yup.string()
            .when(['loaded_container', 'discharged_container'], function () {
              if ((containerChangeState === "yes" ||
                currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH)) {
                return Yup.string().matches(/^\d{1,7}$/, commonValidationMessages.wholenumberupto7digits)
                  .required(commonValidationMessages.required)
              } else {
                return Yup.string().nullable();
              }
            }),
        }).test("total_onboard_container", function () {
          const values: any = this.parent ?? {};
          if (parseInt(values?.container_detail?.total_onboard_container) < parseInt(values?.reefer_container_details?.total_onboard_container)) {
            return new Yup.ValidationError("The total number of onboard reefer containers cannot be more than the total number of onboard containers.", undefined, "reefer_container_details.total_onboard_container");
          }
          return true;
        }).test("feet_20", function () {
          const values: any = this.parent ?? {};
          if (parseInt(values?.container_detail?.feet_20) < parseInt(values?.reefer_container_details?.feet_20)) {
            return new Yup.ValidationError("There cannot be more 20 ft units of reefer containers than the total number of 20 ft containers.", undefined, "reefer_container_details.feet_20");
          }
          return true;
        }).test("feet_40", function () {
          const values: any = this.parent ?? {};
          if (parseInt(values?.container_detail?.feet_40) < parseInt(values?.reefer_container_details?.feet_40)) {
            return new Yup.ValidationError("There cannot be more 40 ft units of reefer containers than the total number of 40 ft containers.", undefined, "reefer_container_details.feet_40");
          }
          return true;
        }).test("loaded_container", function () {
          const values: any = this.parent ?? {};
          if (parseInt(values?.container_detail?.loaded_container) < parseInt(values?.reefer_container_details?.loaded_container)) {
            return new Yup.ValidationError("Total containers loaded cannot be less than total containers loaded of reefer container", undefined, "reefer_container_details.loaded_container");
          }
          return true;
        }).test("discharged_container", function () {
          const values: any = this.parent ?? {};
          if (parseInt(values?.container_detail?.discharged_container) < parseInt(values?.reefer_container_details?.discharged_container)) {
            return new Yup.ValidationError("Total containers discharged cannot be less than total containers discharged of reefer container", undefined, "reefer_container_details.discharged_container");
          }
          return true;
        }),
    }),
  }

  /** Calculate LNG cargo ROB */
  const updateTotalCargoOnboard = (
    form: any,
    values: any,
    e: any,
    op: string
  ) => {
    if (op === "loading") {
      form.setFieldValue(
        "cargo_detail.total_amount_of_cargo_onboard",
        (
          parseInt(lngCargoROBPreviousReport?.cargo_rob ?? lngCargoROBCurrentReport?.cargo_rob ?? 0) +
          parseInt(e.target.value) -
          parseInt(values?.cargo_detail?.amount_of_cargo_discharged ?? 0) -
          parseInt(values?.lng_cargo_rob?.cargo_consumed ?? 0) +
          parseInt(values?.cargo_detail?.cargo_adjusted ?? 0)
        )
      );
    } else if (op === "discharging") {
      form.setFieldValue(
        "cargo_detail.total_amount_of_cargo_onboard",
        (
          parseInt(lngCargoROBPreviousReport?.cargo_rob ?? lngCargoROBCurrentReport?.cargo_rob ?? 0) +
          parseInt(values?.cargo_detail?.amount_of_cargo_loaded ?? 0) -
          parseInt(e.target.value) -
          parseInt(values?.lng_cargo_rob?.cargo_consumed ?? 0) +
          parseInt(values?.cargo_detail?.cargo_adjusted ?? 0)
        )
      );
    } else {
      form.setFieldValue(
        "cargo_detail.total_amount_of_cargo_onboard",
        (
          parseInt(lngCargoROBPreviousReport?.cargo_rob ?? lngCargoROBCurrentReport?.cargo_rob ?? 0) +
          parseInt(values?.cargo_detail?.amount_of_cargo_loaded ?? 0) -
          parseInt(values?.cargo_detail?.amount_of_cargo_discharged ?? 0) -
          parseInt(values?.lng_cargo_rob?.cargo_consumed ?? 0) +
          parseInt(e.target.value)
        )
      );
    }
  };

  const prevCargoOnboard = cargoDetailsPreviousReport?.total_amount_of_cargo_onboard
  /**function to calculate if the total cargo on boaed is within 5% margin of error 
   * @param total_amount_of_cargo_onboard
   * @param amount_of_cargo_discharged
   * @param amount_of_cargo_loaded
   * sets up the alert popup 
  */
  const handleCargoOnboardBlur = (reportedQty: number, cargoLoaded: number, cargoDischarged: number) => {
    const calculatedQty = prevCargoOnboard + cargoLoaded - cargoDischarged;
    if (env?.alerts && (reportedQty < calculatedQty * 0.95 || reportedQty > calculatedQty * 1.05)) {
      setAlertBool(true);
      setAlertMessage(
        getAlertMessage(
          "CargoDetails",
          "total_amount_of_cargo_onboard",
          "Total Amount of Cargo Onboard",
          reportedQty,
          calculatedQty
        )
      );
      setAlertColourType(AlertColourTypeConstant.DANGER);
      setAlertType(AlertTypeConstant.WITH_REASON);
      setFieldId("total_amount_of_cargo_onboard");
      setFormTitle("Cargo Details");
      setFieldLabel("Total Amount of Cargo Onboard");
      setFieldValue(reportedQty);
    }
  };

  const AmountOfCargoDischagedOnBlur = (e: any, values: any, handleBlur: any, handleChange: any, form: any) => {
    if (env?.alerts && prevCargoOnboard !== undefined &&
      e.target.value > cargoDetailsPreviousReport?.total_amount_of_cargo_onboard) {
      setAlertBool(true);
      setAlertMessage(
        getAlertMessage(
          "CargoDetails",
          "amount_of_cargo_discharged",
          "Amount of Cargo Discharged",
          e.target.value,
          cargoDetailsPreviousReport?.total_amount_of_cargo_onboard
        )
      );
      setAlertColourType(AlertColourTypeConstant.DANGER);
      setAlertType(AlertTypeConstant.WITH_REASON);
      setFieldId("amount_of_cargo_discharged")
      setFormTitle("Cargo Details");
      setFieldLabel("Amount of Cargo Discharged");
      setFieldValue(e.target.value);
    }
    if (env?.alerts && e.target.value !== null && values?.cargo_detail?.total_amount_of_cargo_onboard !== null) {
      handleCargoOnboardBlur(
        parseFloat(values?.cargo_detail?.total_amount_of_cargo_onboard),
        parseFloat(values?.cargo_detail?.amount_of_cargo_loaded),
        parseFloat(e.target.value),
      )
    }
    handleBlur(e);
    handleChange(e);
    if (
      e.target.value !== null &&
      e.target.value > 0
    ) {
      form.setFieldValue(
        "cargo_detail.discharging",
        true
      );
    } else {
      form.setFieldValue(
        "cargo_detail.discharging",
        false
      );
    }
    if (
      CurrentVessel?.vessel_type_precedence_id ===
      VesselTypeConstant.LNG_CARRIER
    ) {
      updateTotalCargoOnboard(
        form,
        values,
        e,
        "discharging"
      );
    }
  }

  /** Calculate Total cargo onboard */
  const calculateTotalCargoOnboard = (ft20: number, ft40: number, setFieldValue: any, path: string) => {
    setFieldValue(path, (Number.isNaN((ft20 ?? 0) + (ft40 * 2)) ? 0 : (ft20 ?? 0) + (ft40 * 2)));
  }


  const checkCondition = (
    VesselGenInfoObject: any,
    DraftsDisplacementObject: any
  ): "laden" | "ballast" | null => {
    if (checkValidObject(VesselGenInfoObject) && checkValidObject(DraftsDisplacementObject)) {
      return DraftsDisplacementObject?.draft_mid > VesselGenInfoObject?.max_ballast_draft
        ? "laden"
        : "ballast";
    }
    return null;
  };
  const loadingCondition = checkCondition(VesselGenInfoObject, draftsDisplacementCurrentReport);

  /**combined loading state of all queries */
  const isLoading = (
    reportingLoading ||
    InitialLNGCargoObjectLoading ||
    VesselLNGTanksLoading
  );

  return (
    <Card className="deck-card-body mb-0 border-0">
      {isLoading && <FormLoading />}
      {reportingError && <ErrorComponent message="Error loading required data!" />}
      {!isLoading && !reportingError && (
        <Formik
          onSubmit={async (values: any, actions: any) => {
            if (env?.form_validation === false || (isFormUnchanged(DraftCargoLadingFormik.initialValues, values) &&
              blFileUpload?.length === 0)
            ) {
              setErrorMessage(null)
              toggleTab(previousDeckTabIndex + 1);
              return;
            }
            actions.setSubmitting(true);
            const responseArray: any = [];
            /** Drafts & Displacement submit */
            if (checkValidObject(draftsDisplacementCurrentReport) && values.draft_and_displacement.id > 0) {
              responseArray.push(apiGlobal
                .put(`/draft_and_displacement/${values.draft_and_displacement.id}/`, values.draft_and_displacement))
            } else {
              responseArray.push(apiGlobal.post(`/draft_and_displacement/`, values.draft_and_displacement))
            }
            /** Ballast Details submit */
            if (checkValidObject(ballastDetailsCurrentReport) && values?.ballast_details.id > 0) {
              responseArray.push(apiGlobal.put(`/ballast_details/${values?.ballast_details.id}/`, values?.ballast_details))
            } else {
              responseArray.push(apiGlobal.post(`/ballast_details/`, values.ballast_details))
            }
            /** Cargo Details submit */
            if (CurrentVessel?.vessel_type_precedence_id !== VesselTypeConstant.CONTAINER) {
              if (currentVesselReport?.is_this_cargo_loading_discharging !== cargoChangeState) {
                setCargoDetailsId(values.cargo_detail.id);
                await responseArray.push(apiGlobal.patch(`/vessel_reporting_information/${ReportID}/`,
                  {
                    is_this_cargo_loading_discharging: cargoChangeState
                  }
                ))
              }
              if (cargoChangeState === "yes") {
                if (checkValidObject(cargoDetailsCurrentReport) && values.cargo_detail.id > 0) {
                  await responseArray.push(apiGlobal.put(`/cargo_detail/${values.cargo_detail.id}/`, values.cargo_detail))
                } else {
                  await responseArray.push(apiGlobal.post(`/cargo_detail/`, values.cargo_detail))
                }
              }
            }
            /** container Details submit */
            if ((CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER || CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP) &&
              is_container_available === true) {
              if (currentVesselReport?.change_in_containers_onboard !== containerChangeState) {
                await responseArray.push(apiGlobal.patch(`/vessel_reporting_information/${ReportID}/`,
                  {
                    change_in_containers_onboard: containerChangeState
                  }
                ))
              }
              if (containerChangeState === "yes") {
                if (checkValidObject(containerDetailsCurrentReport) && values?.container_detail?.id > 0) {
                  await responseArray.push(apiGlobal.put(`/container_detail/${values.container_detail.id}/`, values.container_detail))
                } else {
                  await responseArray.push(apiGlobal.post(`/container_detail/`, values.container_detail))
                }
              }
            }
            /** Bill of Lading submit */
            if ((values?.cargo_detail?.amount_of_cargo_loaded > 0 || values?.cargo_detail?.amount_of_cargo_discharged > 0)
              && values?.cargo_detail?.total_amount_of_cargo_onboard !== null) {
              if (checkValidObject(billOfLadingCurrentReport) && values?.bill_of_lading?.id > 0) {
                if (values?.bill_of_lading?.is_bill_of_lading_issued_since_last_report === false) {
                  // Delete existing Bill of Lading
                  responseArray.push(apiGlobal.delete(`/bill_of_lading/${values?.bill_of_lading?.id}/`));
                } else {
                  // Update existing Bill of Lading with optional file upload
                  const formData = new FormData();
                  Object.keys(values.bill_of_lading).forEach((item: any) => {
                    formData.append(item, values.bill_of_lading[item]);
                  });
                  if (blFileUpload && blFileUpload[0]?.file) {
                    formData.append("bl_file_uploads", blFileUpload[0].file);
                  }
                  await responseArray.push(apiMedia.put(`/bill_of_lading/${values.bill_of_lading.id}/`, formData));
                }
              } else {
                if (values?.bill_of_lading?.is_bill_of_lading_issued_since_last_report === true) {
                  // Create new Bill of Lading with optional file upload
                  const formData = new FormData();
                  Object.keys(values.bill_of_lading).forEach((item: any) => {
                    formData.append(item, values.bill_of_lading[item]);
                  });
                  if (blFileUpload && blFileUpload[0]?.file) {
                    await formData.append("bl_file_uploads", blFileUpload[0].file);
                  }
                  await responseArray.push(apiMedia.post(`/bill_of_lading/`, formData));
                }
              }
            } else {
              if (checkValidObject(billOfLadingCurrentReport)) {
                await responseArray.push(apiGlobal.delete(`/bill_of_lading/${values?.bill_of_lading?.id}/`));
              }
            }
            /** Reefer Containers submit */
            if ((CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER || CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP) &&
              reefer_container_available === true && containerChangeState === "yes") {
              if (checkValidObject(reeferContainerDetailsCurrentReport) && values.reefer_container_details.id > 0) {
                const formData = new FormData();
                Object.keys(values.reefer_container_details).forEach((item: any) => {
                  formData.append(item, values.reefer_container_details[item]);
                });
                if (baplieFiles && baplieFiles[0].file) {
                  formData.append("baplie_file", baplieFiles[0].file);
                }
                if (logBook && logBook[1]?.file) {
                  formData.append("log_book_upload", logBook[1]?.file);
                }
                responseArray.push(apiMedia.put(`/reefer_container_details/${values.reefer_container_details.id}/`, formData));
              } else {
                const formData = new FormData();
                Object.keys(values.reefer_container_details).forEach((item: any) => {
                  formData.append(item, values.reefer_container_details[item]);
                });
                if (baplieFiles && baplieFiles[0].file) {
                  formData.append("baplie_file", baplieFiles[0].file);
                }
                if (logBook && logBook[1]?.file) {
                  formData.append("log_book_upload", logBook[1]?.file);
                }
                responseArray.push(apiMedia.post(`/reefer_container_details/`, formData));
              }
            }
            /** Update intial LNG Cargo ROB */
            if (
              CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER &&
              currentVesselReport &&
              currentVesselReport?.is_this_cargo_loading_discharging === 'yes'
            ) {
              if (values.cargo_detail.amount_of_cargo_loaded > 0) {
                values.n2_adjustment.loaded_cargo =
                  values?.cargo_detail?.amount_of_cargo_loaded;
                values.n2_adjustment.loading_ctms = loadingCTMS;
              }
              if (values.cargo_detail.amount_of_cargo_discharged > 0) {
                values.n2_adjustment.discharge_cargo =
                  values?.cargo_detail?.amount_of_cargo_discharged;
                values.n2_adjustment.discharge_ctms = dischargingCTMS;
              }
              if (values?.cargo_detail?.loading_completion === true) {
                values.n2_adjustment.start_report = ReportID;
              }
              if (values?.cargo_detail?.discharging_completion === true) {
                values.n2_adjustment.end_report = ReportID;
              }
              if (
                values?.n2_adjustment?.end_report !== null ||
                InitialLNGCargoObject[0]?.start_report === ReportID
              ) {
                responseArray.push(
                  apiGlobal.put(`/n2_adjustment/${values?.n2_adjustment?.id}/`, values?.n2_adjustment))
              } else if (
                values?.n2_adjustment?.start_report === ReportID &&
                InitialLNGCargoObject[0]?.start_report !== ReportID
              ) {
                const res = await apiGlobal.post(`/n2_adjustment/`, values?.n2_adjustment)
                if (res.status === 201) {
                  setInitialLNGCargoId(res?.data?.id);
                }
                responseArray.push(res);
              }
            }
            /** Submit LNG cargo ROB */
            if (
              CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER &&
              currentVesselReport &&
              currentVesselReport?.is_this_cargo_loading_discharging === 'yes'
            ) {
              if (values?.cargo_detail?.amount_of_cargo_loaded > 0) {
                values.lng_cargo_rob.cargo_loaded_cargo_detail =
                  cargoDetailsId === 0 ? cargoDetailsCurrentReport?.id : cargoDetailsId;
              }
              if (values?.cargo_detail?.amount_of_cargo_discharged > 0) {
                values.lng_cargo_rob.cargo_discharge_cargo_detail =
                  cargoDetailsId === 0 ? cargoDetailsCurrentReport?.id : cargoDetailsId;
              }
              if (values?.n2_adjustment?.start_report === ReportID) {
                values.lng_cargo_rob.lng_initial_cargo_rob =
                  initialLNGCargoId;
                values.lng_cargo_rob.cargo_rob =
                  values.cargo_detail.total_amount_of_cargo_onboard;
              }
              values.lng_cargo_rob.lng_initial_cargo_rob =
                InitialLNGCargoObject[0]?.id;
              values.lng_cargo_rob.cargo_rob = parseFloat(
                values.cargo_detail.total_amount_of_cargo_onboard
              );
              if (checkValidObject(lngCargoROBCurrentReport) && values?.lng_cargo_rob?.id > 0) {
                responseArray.push(apiGlobal.put(`/lng_cargo_rob/${values?.lng_cargo_rob?.id}/`, values?.lng_cargo_rob))
              } else {
                responseArray.push(apiGlobal.post(`/lng_cargo_rob/`, values?.lng_cargo_rob))
              }
            }
            /** Cargo Parameters Submit */
            if (
              checkValidObject(CurrentVessel) &&
              CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER
            ) {
              if (checkValidArray(vesselLNGTanksCurrentReport)) {
                values.vessel_reporting_lng_tank_detail.forEach((lngTank: any) => {
                  responseArray.push(apiGlobal
                    .put(`/vessel_reporting_lng_tank_detail/${lngTank.id}/`, lngTank))
                });
              } else {
                responseArray.push(apiGlobal.post(`/vessel_reporting_lng_tank_detail/`, values.vessel_reporting_lng_tank_detail))
              }
            }
            await handleServerResponse(responseArray).then(async (res) => {
              if (res === true) {
                setBaplieFiles([{}])
                setBLFileUpload([])
                dispatch(getLimitsAndAlertsAction(`get_data_for_limits_and_alerts/?vessel_id=${VesselID}&load_condition=${loadingCondition}&speed=${calculateSpeed(
                  checkValidObject(currentVesselReport) ? currentVesselReport?.distance_travelled : 0,
                  checkValidObject(currentVesselReport) ? currentVesselReport?.time_duration_since_last_report : 0
                )}`));
                if (env?.form_validation === true) {
                  setErrorMessage(null)
                  toggleTab(previousDeckTabIndex + 1);
                  actions.setSubmitting(false);
                }
                await dispatch(getCurrentReportAction(VesselID, ReportID));
                await dispatch(getCurrentReportFilesAction(ReportID, VesselID));
                if (CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER) {
                  await queryClient.invalidateQueries(queryKeyes.vessel.InitialLNGCargoROBObject.key);
                  await queryClient.invalidateQueries(queryKeyes.vessel.LNGCargoQualityObject.key);
                }
              } else if (Array.isArray(res)) {
                if (res.filter((item: any) => item.status === "fulfilled")?.length > 0) {
                  res.filter((item: any) => item.status === "fulfilled")?.forEach(async (obj: any) => {
                    dispatch(getCurrentReportAction(VesselID, ReportID));
                    const apiURL = obj?.value?.config?.url?.replace(/\d+/g, "").replace(/\/$/, "");
                    if ((CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER ||
                      CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP) &&
                      reefer_container_available === true &&
                      currentVesselReport && ((currentVesselReport?.reporting_event !== ReportingEvents.NOON_FWE_IP &&
                        currentVesselReport?.reporting_event !== ReportingEvents.DEPARTURE_FROM_BERTH &&
                        currentVesselReport?.is_this_cargo_loading_discharging === "yes") ||
                        (currentVesselReport?.reporting_event === ReportingEvents.NOON_FWE_IP ||
                          currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH)) &&
                      apiURL === "/reefer_container_details/") {
                      setBaplieFiles([{}])
                    } else if (CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER) {
                      if (apiURL === "/lng_cargo_rob/") {
                        await queryClient.invalidateQueries(queryKeyes.vessel.InitialLNGCargoROBObject.key);
                      } else if (apiURL === "/n2_adjustment/") {
                        await queryClient.invalidateQueries(queryKeyes.vessel.InitialLNGCargoROBObject.key);
                      }
                    }
                  })
                }
                setErrorMessage(res)
                setAlertBool(false)
                dynamicSetFieldErrors(res, actions)
              }
              actions.setSubmitting(false);
            })
          }}
          initialValues={DraftCargoLadingFormik.initialValues}
          validationSchema={env?.form_validation === true ? DraftCargoLadingFormik.validationSchema : null}
        // key={refreshKey}
        >
          {({
            values,
            errors,
            handleSubmit,
            setErrors,
            isSubmitting,
            validateForm,
            setFieldTouched,
          }: {
            values: any;
            errors: any;
            handleSubmit: any;
            setErrors: any;
            isSubmitting: any;
            validateForm: any;
            setFieldTouched: any;
          }) => (
            <Form id="form" autoComplete="off" onSubmit={handleSubmit} noValidate>
              <React.Fragment>
                {/* Draft And Displacement Compoenent */}
                <DraftsAndDisplacement
                  containerChangePopupBool={containerChangePopupBool}
                  cargoChangePopupBool={cargoChangePopupBool}
                  alertBool={alertBool}
                  refreshKey={prevRefreshKey}
                  setRefreshKey={setPrevRefreshKey}
                  editValues={editValues}
                  setEditValues={setEditValues}
                  editReportBool={editReportBool}
                />
                {/* Cargo Tank Parameter Component */}
                {CurrentVessel?.vessel_type_precedence_id !== VesselTypeConstant.CONTAINER &&
                  <CargoDetails
                    alertBool={alertBool}
                    handleCargoOnboardBlur={handleCargoOnboardBlur}
                    updateTotalCargoOnboard={updateTotalCargoOnboard}
                    setLoadingPopOverBool={setLoadingPopOverBool}
                    setLoadingPopUpBool={setLoadingPopUpBool}
                    loadingPopOverBool={loadingPopOverBool}
                    loadingPopUpBool={loadingPopUpBool}
                    setLoadingCTMS={setLoadingCTMS}
                    AmountOfCargoDischagedOnBlur={AmountOfCargoDischagedOnBlur}
                    setDischargingPopOverBool={setDischargingPopOverBool}
                    setDischargingPopUpBool={setDischargingPopUpBool}
                    setDischargingCTMS={setDischargingCTMS}
                    dischargingPopUpBool={dischargingPopUpBool}
                    dischargingPopOverBool={dischargingPopOverBool}
                    cargoChangeState={cargoChangeState}
                    setCargoChangeState={setCargoChangeState}
                    previousCargoDetails={previousCargoDetails}
                    setPreviousCargoDetails={setPreviousCargoDetails}
                    editValues={editValues}
                    setEditValues={setEditValues}
                    setCargoChangePopupBool={setCargoChangePopupBool}
                    cargoChangePopupBool={cargoChangePopupBool}
                  />
                }
                {is_container_available === true &&
                  <ContainerDetails
                    alertBool={alertBool}
                    handleCargoOnboardBlur={handleCargoOnboardBlur}
                    AmountOfCargoDischagedOnBlur={AmountOfCargoDischagedOnBlur}
                    containerChangeState={containerChangeState}
                    setContainerChangeState={setContainerChangeState}
                    previousContainerDetailBool={previousContainerDetailBool}
                    setPreviousContainerDetailBool={setPreviousContainerDetailBool}
                    setContainerChangePopupBool={setContainerChangePopupBool}
                    containerChangePopupBool={containerChangePopupBool}
                    calculateTotalCargoOnboard={calculateTotalCargoOnboard}
                    editValues={editValues}
                    setEditValues={setEditValues}
                  />
                }
                {CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER && (
                  <CargoTankParameter
                    alertBool={alertBool}
                    editValues={editValues}
                    setEditValues={setEditValues}
                  />
                )}
                {/* Reefer conatainer Details components */}
                {(CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER ||
                  CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP) &&
                  reefer_container_available === true &&
                  checkValidObject(currentVesselReport) &&
                  <ReeferContainerComponent
                    alertBool={alertBool}
                    deleteBaplieFileObj={deleteBaplieFileObj}
                    setRefreshKey={setRefreshKey}
                    refreshKey={refreshKey}
                    baplieFiles={baplieFiles}
                    setBaplieFiles={setBaplieFiles}
                    deleteLogBookObj={deleteLogBookObj}
                    logBook={logBook}
                    setLogBook={setLogBook}
                    cargoChange={currentVesselReport?.change_in_containers_onboard}
                    previousReeferDetails={previousContainerDetailBool}
                    containerChangePopupBool={containerChangePopupBool}
                    calculateTotalCargoOnboard={calculateTotalCargoOnboard}
                    containerChangeState={containerChangeState}
                    editValues={editValues}
                    setEditValues={setEditValues}
                    editReportBool={editReportBool}
                  />
                }
                {/* Bill of ladding component */}
                {((values?.cargo_detail?.amount_of_cargo_loaded > 0 || values?.cargo_detail?.amount_of_cargo_discharged > 0)
                  && values?.cargo_detail?.total_amount_of_cargo_onboard !== null) &&
                  <BillOfLading
                    cargoChangePopupBool={cargoChangePopupBool}
                    alertBool={alertBool}
                    editValues={editValues}
                    setEditValues={setEditValues}
                    editReportBool={editReportBool}
                    setBLFileUpload={setBLFileUpload}
                    blFileUpload={blFileUpload}
                  />
                }
                {/* Ballast Details Component */}
                <BallastDetails
                  cargoChangePopupBool={cargoChangePopupBool}
                  alertBool={alertBool}
                  refreshKey={prevRefreshKey}
                  editValues={editValues}
                  setEditValues={setEditValues}
                />
                {/* Ballast Operations Component */}
                <BallastOperations
                  cargoChangePopupBool={cargoChangePopupBool}
                  alertBool={alertBool}
                  refreshKey={prevRefreshKey}
                  editValues={editValues}
                  setEditValues={setEditValues}
                />
                {/* Alert Popup component */}
                {alertBool &&
                  <AlertPopup
                    state={alertBool}
                    setState={setAlertBool}
                    alertMessage={alertMessage}
                    setAlertMessage={setAlertMessage}
                    AlertColourType={alertColourType}
                    setAlertColourType={setAlertColourType}
                    alertType={alertType}
                    setAlertType={setAlertType}
                    formTitle={formTitle}
                    fieldId={fieldId}
                    fieldLabel={fieldLabel}
                    fieldValue={fieldValue}
                  />
                }
                <CardFooter className="p-2 py-3">
                  <Row className="d-flex align-items-center flex-row-reverse">
                    <Col lg={10}>
                      <div className="d-flex flex-wrap gap-3 justify_right">
                        {/* {editReportBool &&
                          <Button
                            type="reset"
                            color="danger"
                            className="btn_size_cstm"
                            onClick={() => {
                              setEditValues({
                                ...editValues,
                                deck_officer: {
                                  ...editValues?.deck_officer,
                                  draft_and_displacement: editInitialValues?.deck_officer?.draft_and_displacement,
                                  cargo_detail: editInitialValues?.deck_officer?.cargo_detail,
                                  container_detail: editInitialValues?.deck_officer?.container_detail,
                                  reefer_container_details: editInitialValues?.deck_officer?.reefer_container_details,
                                  bill_of_lading: editInitialValues?.deck_officer?.bill_of_lading,
                                  ballast_details: editInitialValues?.deck_officer?.ballast_details,
                                  vessel_reporting_lng_tank_detail: editInitialValues?.deck_officer?.vessel_reporting_lng_tank_detail,
                                }
                              });
                              const initialCargoChangeState = editReportBool
                                ? editInitialValues?.vessel_reporting_information?.is_this_cargo_loading_discharging
                                : currentVesselReport?.is_this_cargo_loading_discharging;
                              setCargoChangeState(initialCargoChangeState);
                              const initialContainerChangeState = editReportBool
                                ? editInitialValues?.vessel_reporting_information?.change_in_containers_onboard
                                : currentVesselReport?.change_in_containers_onboard;
                              setContainerChangeState(initialContainerChangeState);

                              setRefreshKey(refreshKey + 1);
                            }}
                          >
                            Reset
                          </Button>
                        } */}
                        <Button
                          id="next-btn"
                          type={editReportBool ? "button" : "submit"}
                          color="primary"
                          className="btn_size_cstm"
                          disabled={isSubmitting || editIsSubmitting}
                          onClick={async () => {
                            const validationErrors = await validateForm();
                            const nestedObjects = [
                              "ballast_details",
                              "bill_of_lading",
                              "cargo_detail",
                              "container_detail",
                              "draft_and_displacement",
                              "reefer_container_details",
                            ];
                            nestedObjects.forEach((section) => {
                              Object.keys(values[section] || {}).forEach((key) => {
                                setFieldTouched(`${section}.${key}`, true, false);
                              });
                            });
                            if (editReportBool && Object.keys(validationErrors).length === 0) {
                              await saveEditForm(editSubmit, toggleTab, previousDeckTabIndex, setPreviousDeckTabIndex);
                              setRefreshKey((prev) => prev + 1);
                            }
                          }}
                        >
                          {(isSubmitting || editIsSubmitting) && (
                            <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />
                          )}
                          Next <i className="bx bx-chevron-right ms-1" />
                        </Button>
                      </div>
                    </Col>
                    <Col lg={2}>
                      <Button
                        type="button"
                        color="primary"
                        className="btn_size_cstm"
                        onClick={() => {
                          toggleTab(previousDeckTabIndex - 1);
                          setErrorMessage(null);
                          setErrors({});
                        }}
                      >
                        <i className="bx bx-chevron-left me-1" /> Previous
                      </Button>
                    </Col>
                  </Row>
                </CardFooter>
                <FormValuesDebug
                  values={[
                    values,
                    errors,
                    DraftCargoLadingFormik.initialValues,
                  ]}
                />
              </React.Fragment>
            </Form>
          )}
        </Formik>
      )}
    </Card>
  );
};

export default DraftsCargoLadingComponent;
